import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CpPortalDashboardService } from './cp-portal/cp-portal-dashboard/cp-portal-dashboard.service';
import { LoginCpService } from './cp-portal/login-cp/login-cp.service';
import { SharedService } from 'src/app/shared-components/shared.service';
export var mixpanel = require('mixpanel-browser');
mixpanel.init('102157509afffaee603cf5fe18a43aad', {debug: true, persistence: 'localStorage'});
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'CP DashBoard';
  source : string;
  loginId : string;
  isUser : boolean;
  appId = '';
  navigateTo = '';
  authData = {};
  checkAuth = false;
  screenName:string='';
  constructor(public readonly router: Router, public readonly cpPortalDashboardService: CpPortalDashboardService,
    public readonly loginCpService: LoginCpService, public readonly sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.showLoader();
    const url = window.location.href;
    const sourceParam = this.getQueryUrl('source', url);
    const loginIdParam = this.getQueryUrl('loginId', url) || this.getQueryUrl('loginid', url);
    if (loginIdParam !== null && this.getQueryUrl('navigateTo', url) !== null && this.getQueryUrl('screen_name', url) !== null) {
        console.log("reached11---------")
      this.source = sourceParam || 'cpmobile';
      this.loginId = loginIdParam;
      this.navigateTo = this.getQueryUrl('navigateTo', url);
      this.screenName = this.getQueryUrl('screen_name', url) ? this.getQueryUrl('screen_name', url) : '';
    } else if (this.getQueryUrl('source', url) !== null &&
      this.getQueryUrl('appId', url) !== null &&
      this.getQueryUrl('cpNumber', url) !== null) {
        console.log("reached12---------")
      this.source = this.getQueryUrl('source', url);
      this.loginId = this.getQueryUrl('cpNumber', url);
      this.appId = this.getQueryUrl('appId', url);
    }

    if (this.source === 'cpmobile' && this.loginId) {
      console.log("reached13---------")
      this.sharedService.setLocalStorage('appdata', JSON.stringify({loginid:this.loginId,navigateTo:this.navigateTo, source:this.source,screen_name:this.screenName}));
      mixpanel.identify(`${this.loginId}`);
      mixpanel.people.set({ "Name": `${this.loginId}` });
      sessionStorage.setItem('source', this.source);
      const loginid = { 'LOGIN_ID': this.loginId };
      this.loginCpService.getUserSession(loginid).subscribe((userResp: any) => {
        const selfQrObj = {
          qrDmsId: JSON.parse(userResp['SPDPGETUSERSESSION']['QR_DMS_DETAILS'])['svg'][0]['id'],
          borrowerShortUrl: userResp['SPDPGETUSERSESSION']['BORROWER_SHORT_URL'],
          whatsappConsent: userResp['SPDPGETUSERSESSION']['WHATSAPP_OPTIN'],
          cpName: userResp['SPDPGETUSERSESSION']['USER_NAME'],
          cpUserId: userResp['SPDPGETUSERSESSION']['LOGIN_ID'],
          company_name: userResp['SPDPGETUSERSESSION']['COMPANY_NAME']
        };
        this.sharedService.setLocalStorage('selfQrDetails', JSON.stringify(selfQrObj));
        if (userResp && userResp['SPDPGETUSERSESSION'].CP_USER_ID)
        {
          const userObj = userResp['SPDPGETUSERSESSION'];
          sessionStorage.setItem('cpuserData', JSON.stringify(userObj));
          if (this.appId)
          {
            this.router.navigate(['/cpQrCode']);
          }
          else if (this.navigateTo === 'Dashboard')
          {
            mixpanel.people.set({ "Module": `Dashboard` });
            mixpanel.track('App Visit',{
              "Module": `Dashboard`
            });
            this.router.navigate(['/cpdashboard/dashboard']);
          }
          else if (this.navigateTo === 'spList')
          {
            mixpanel.people.set({ "Module": `Sourcing Partner` });
            mixpanel.track('App Visit',{
              "Module": `Sourcing Partner`
            });
            this.generateByPassOtp();
          }
          else {
            this.router.navigate(['/cplogin']);
          }
          this.sharedService.hideLoader();
          this.isUser = true;
        }
      },
        error => {
          this.sharedService.hideLoader();
        });
    } 
    else if(this.source === 'others' && this.loginId){
      console.log("reached---------")
      const cpcode = this.getQueryUrl('cpcode', url)
      sessionStorage.setItem('cpuserData', JSON.stringify({LOGIN_ID:this.loginId,CP_CODE:cpcode}));
      this.generateByPassOtp();
      this.sharedService.hideLoader();
    }
    else {
      this.isUser = true;
      this.sharedService.hideLoader();
      if (!sessionStorage.getItem('cpuserData'))
      {
        this.router.navigate(['/cplogin']);
        this.sharedService.hideLoader();
      }
    }
  }

  getQueryUrl(key, url) {
    const href = url ? url : window.location.href;
    const reg = new RegExp('[?&]' + key + '=([^&#]*)', 'i');
    const string = reg.exec(href);
    return string ? string[1] : null;
  }

  generateByPassOtp() {
    this.sharedService.showLoader();
    this.loginCpService.generateByPassOtp(this.loginId).subscribe(res => {
      const otpData = res['SPTBGENERATEBYPASSOTP'];
      if (otpData && otpData.response_type === 'I')
      {
        this.authData['LOGIN_ID'] = this.loginId;
        this.authData['beRequestID'] = otpData.be_request_id;
        this.authData['password'] = otpData.otp_text;
        this.loginCpService.checkAuth(this.authData).subscribe((authresp: any) => {
          if (authresp['AUTH2']['p_gprs_string'] === 'Y')
          {
            const loginid = { 'LOGIN_ID': this.authData['LOGIN_ID'] }
            this.loginCpService.auth_vahana(loginid, 'Y').subscribe((resp: any) => {
              if (resp['status'] === true)
              {
                this.loginCpService.getUserSession(loginid).subscribe((userResp: any) => {
                 if(this.navigateTo === 'spList'){
                  const selfQrObj = {
                    qrDmsId: JSON.parse(userResp['SPDPGETUSERSESSION']['QR_DMS_DETAILS'])['svg'][0]['id'],
                    borrowerShortUrl: userResp['SPDPGETUSERSESSION']['BORROWER_SHORT_URL'],
                    whatsappConsent: userResp['SPDPGETUSERSESSION']['WHATSAPP_OPTIN'],
                    cpName: userResp['SPDPGETUSERSESSION']['USER_NAME'],
                    cpUserId: userResp['SPDPGETUSERSESSION']['LOGIN_ID'],
                  };
                  this.sharedService.setLocalStorage('selfQrDetails', JSON.stringify(selfQrObj));
                  if (userResp && userResp['SPDPGETUSERSESSION'].CP_USER_ID)
                  {
                    const userObj = userResp['SPDPGETUSERSESSION'];
                    sessionStorage.setItem('cpuserData', JSON.stringify(userObj));
                  }
                 }
                 else{
                  this.router.navigate(['/cpmarketing/marketing-campaign'])
                 }
                }, (err: any) => {
                  this.sharedService.hideLoader();
                })
              }
            }, (err: any) => {
              this.sharedService.hideLoader();
            })
          } else
          {
            this.sharedService.showError('Entered OTP is invalid', 'error');
            this.sharedService.hideLoader();
          }
        }, (err: any) => {
          this.sharedService.showError('Please Entered Valid OTP', 'error');
          this.sharedService.hideLoader();
        })
      }
      else if (otpData && otpData.response_type === 'E') 
      {
        this.sharedService.hideLoader();
      }
    });
  }

  ngOnDestroy(){
    mixpanel.track(`App Exit`,{
      "Module": `Lender Corner`
    });
    mixpanel.reset();
  }
}
